import { render, staticRenderFns } from "./qnaDetailPage.vue?vue&type=template&id=280397bb&scoped=true&"
import script from "./qnaDetailPage.vue?vue&type=script&lang=js&"
export * from "./qnaDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./qnaDetailPage.vue?vue&type=style&index=0&id=280397bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280397bb",
  null
  
)

export default component.exports